import React, { useState, useEffect } from "react";
import MainHeader from "../common/MainHeader";
import { baseUrl, FooterName } from "../../Utility/constants";
import axios from "axios";
import { toast } from "react-toastify";
import useSchoolData from "../../hooks/useSchoolData";

const HomePage = () => {
  const {
    schoolInfo,
    schoolContactInfo,
    schoolId,
    loading
  } = useSchoolData();

  const currentYear = new Date().getFullYear();
  const standardApiUrl = `${baseUrl}/api/StandardMaster/GetStandardBySchool`;
  useEffect(() => {
    // Clear user data from local storage
    localStorage.removeItem("userEmail");
    localStorage.removeItem("Role");
    localStorage.removeItem("userID");
  }, []);

  return (
    <div>
      <MainHeader orgname={schoolInfo?.schoolOrCollegeName} />
      <div className="container mt-5">
        {/* Hero Section */}
        {(schoolInfo?.organizationName && schoolContactInfo?.city) &&
          <div className="text-center mb-3">
            <h4>Welcome to {schoolInfo?.organizationName} (Since {schoolInfo?.establishmentYear})</h4>
             <h2>
              {schoolInfo?.schoolOrCollegeName},{schoolContactInfo?.city},Tal.{schoolContactInfo?.taluka},Dist.{schoolContactInfo?.district}{schoolContactInfo?.pincode}
            </h2> 
          </div>
        } <br></br>
        <div className="row mb-5">
          {/* Notifications / Announcements */}
        <div className="row mb-5">
          <div className="col-6">
            <h2 className="mb-3">Latest Announcements</h2>
            <ul className="list-group">
              <li className="list-group-item">
                📌 Admissions for 2026-27 are now open. Apply online via the portal.
              </li>
              <li className="list-group-item">
                📚 Mid-term exams begins soon.
              </li>
              <li className="list-group-item">
                🧾 Due date for payment comes soon.
              </li>
              <li className="list-group-item">
                🎓 Graduation Ceremony arrives soon.
              </li>
              <li className="list-group-item">
                🚌 New bus routes and stops updated in the Transport section.
              </li>
            </ul>
          </div>
          {/* About Portal */}
          <div className="col-md-6">
            <h2>About Us</h2>
            <p style={{ textAlign: "justify" }}>
              The Panacea School Management System is your all-in-one digital assistant for modern schooling. Designed to streamline operations, enhance communication, and deliver academic excellence, it brings the entire school ecosystem under one roof.
            </p>
            <ul>
              <li>Paperless admissions and record management</li>
              <li>24x7 access to student and parent dashboards</li>
              <li>Digitized report cards and exam schedules</li>
			  <li>Library, transport, and fee modules integrated</li>
            </ul>
      </div>
        </div>  
        {/* Quick Stats / More Tiles */}
          <div className="col-md-12">
            <div className="row text-center margin-bottom: 20px;">
              <div className="col-3 mb-4">
                <div className="card p-3 h-100">
                  <i className="fas fa-user-graduate fa-2x text-info mb-2"></i>
                  <h6>500+ Students</h6>
                </div>
              </div>
              <div className="col-3 mb-4">
                <div className="card p-3 h-100">
                  <i className="fas fa-chalkboard-teacher fa-2x text-secondary mb-2"></i>
                  <h6>14+ Teachers</h6>
                </div>
              </div>
              <div className="col-3 mb-4">
                <div className="card p-3 h-100">
                  <i className="fas fa-school fa-2x text-success mb-2"></i>
                  <h6>15+ Years of Excellence</h6>
                </div>
              </div>
              <div className="col-3 mb-4">
                <div className="card p-3 h-100">
                  <i className="fas fa-globe fa-2x text-primary mb-2"></i>
                  <h6>Smart Digital Campus</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
		{/* Features Tiles Section */}
        <div className="row text-center mb-5">
          <div className="col-md-3 mb-4">
            <div className="card shadow h-100 p-3">
              <i className="fas fa-user-check fa-2x text-primary mb-2"></i>
              <h5>Attendance</h5>
              <p className="small">Track daily attendance and leave status in real-time.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card shadow h-100 p-3">
              <i className="fas fa-book fa-2x text-success mb-2"></i>
              <h5>Assignments</h5>
              <p className="small">Submit homework and view feedback from teachers.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card shadow h-100 p-3">
              <i className="fas fa-poll fa-2x text-warning mb-2"></i>
              <h5>Results</h5>
              <p className="small">View academic performance and progress reports.</p>
            </div>
          </div>
          <div className="col-md-3 mb-4">
            <div className="card shadow h-100 p-3">
              <i className="fas fa-comments fa-2x text-danger mb-2"></i>
              <h5>Communication</h5>
              <p className="small">Stay connected with teachers and receive school updates.</p>
            </div>
          </div>
        </div>
      </div>

      <footer
        className="fixed-bottom"
        style={{
          backgroundColor: "black",
          color: "#6c757d",
          textAlign: "center",
          padding: "10px 0",
          boxShadow: "0 -1px 5px rgba(0, 0, 0, 0.1)",
          width: "100%",
        }}
      >
        <div className="container">
          <p className="mb-0" style={{ color: "white" }}>
            Copyright &copy; 2017-{currentYear} {FooterName} | All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
